import React, { CSSProperties } from 'react';
import './success-check-sparkle.css';

type SparkVars = CSSProperties & {
  '--sx': string;
  '--sy': string;
  '--ex': string;
  '--ey': string;
  '--d': string;
};

const spark = (
  sx: string,
  sy: string,
  ex: string,
  ey: string,
  d: string,
): SparkVars => ({
  '--sx': sx,
  '--sy': sy,
  '--ex': ex,
  '--ey': ey,
  '--d': d,
});

/**
 * Decorative success check with a one-shot sparkle animation (~1.22s).
 * Page heading should carry the accessible meaning.
 */
const SuccessCheckSparkle = (): React.ReactElement => (
  <svg
    className="sc sc--sparkle"
    viewBox="-28 -28 136 136"
    width="136"
    height="136"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle className="sc-spark" cx="40" cy="40" r="2" style={spark('31.9px', '11.6px', '54.5px', '19.8px', '0ms')} />
    <circle className="sc-spark" cx="40" cy="40" r="1.5" style={spark('8.8px', '32.8px', '16.3px', '60.9px', '60ms')} />
    <circle className="sc-spark" cx="40" cy="40" r="2.5" style={spark('-21.9px', '26.0px', '-36.0px', '42.9px', '20ms')} />
    <circle className="sc-spark" cx="40" cy="40" r="1.5" style={spark('-33.5px', '5.9px', '-63.0px', '11.1px', '100ms')} />
    <circle className="sc-spark" cx="40" cy="40" r="2" style={spark('-27.9px', '-19.5px', '-49.1px', '-34.4px', '40ms')} />
    <circle className="sc-spark" cx="40" cy="40" r="2.5" style={spark('5.9px', '-33.5px', '9.9px', '-56.1px', '80ms')} />
    <circle className="sc-spark" cx="40" cy="40" r="1.5" style={spark('29.4px', '-17.0px', '54.6px', '-31.5px', '120ms')} />
    <circle className="sc-disc" cx="40" cy="40" r="40" />
    <path className="sc-mark" pathLength={1} d="M21.65 41.47 L33.96 52.24 L61.65 27.62" />
  </svg>
);

export default SuccessCheckSparkle;
